import { render, staticRenderFns } from "./ucapan-ulang-tahun.vue?vue&type=template&id=5ba302b3&"
import script from "./ucapan-ulang-tahun.vue?vue&type=script&lang=js&"
export * from "./ucapan-ulang-tahun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports